import { updateUser } from '../../services/updateUser';

export function updateUserAction (userUpdate, tokenPartners) {
  return {
    type: 'UPDATE_USER',
    payload: updateUser(userUpdate, tokenPartners)
  }
}